// components
import { LAYOUT_DEFAULT } from "../components/layouts";

export default function PAGE_CALENDAR () {
    return (
        <LAYOUT_DEFAULT pageName={ "calendar" }>
            <section>Calendar</section>
        </LAYOUT_DEFAULT>
    )
}